import {Component, HostListener, OnInit} from '@angular/core';
import {City, Customer, CustomerLite, Rabat, Supplier} from '../model';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DateAdapter, MatDialog} from '@angular/material';
import {ApiServiceService} from '../api-service.service';
import {MainComponent} from '../main/main.component';
import {DialogComponent} from '../dialog/dialog.component';
import {SupplierComponent} from '../supplier/supplier.component';
import {RabatComponentComponent} from '../rabat-component/rabat-component.component';

@Component({
  selector: 'app-rabats',
  templateUrl: './rabats.component.html',
  styleUrls: ['./rabats.component.scss']
})
export class RabatsComponent implements OnInit {

  public loading = false;
  public sort = 'created_at';
  public dir = 'desc';
  public page = 0;
  public rabats: Rabat[];
  public total = 0;
  public selected = [];
  public showText = true;
  public showHeader = true;
  public logoWidth = 30;
  public supplier: Supplier;
  public customers: CustomerLite[];
  public suppliers: Supplier[];
  public filter = { dateFrom: -1, dateTo: -1, id: '', customer: [ 0 ], supplier: [ 0 ],
    condition: -1, discountType: -1, priceMin: 0, priceMax: 0, percentMin: 0, percentMax: 0 };

  constructor(private router: Router, private translate: TranslateService, private dialog: MatDialog, private apiService: ApiServiceService, private main: MainComponent,   private dateAdapter: DateAdapter<Date>) {
  }

  public ngOnInit() {
    this.dateAdapter.setLocale('sr');
    this.dateAdapter.getFirstDayOfWeek = () => { return 1; };
    this.supplier = JSON.parse(localStorage.getItem('supplier'));

    if (window.innerWidth > 800) {
      this.showText = true;
      this.logoWidth = 30;
    } else {
      this.logoWidth = 50;
      this.showText = false;
    }

    this.filterRabats();
    this.getSuppliersAndCustomers();
  }

  public getSuppliersAndCustomers() {
    this.apiService.getAllCustomers().subscribe(
      (data: CustomerLite[]) => {
        this.customers = data;
      }
    );
    this.apiService.getAllSuppliers().subscribe(
      (data: Supplier[]) => {
        this.suppliers = data;
      }
    );
  }

  public resetFilterCustomer() {
    this.filter.customer = [ 0 ];
  }

  public resetFilterSupplier() {
    this.filter.supplier = [ 0 ];
  }

  public checkCustomers() {
    if (this.filter.customer.length > 1 && this.filter.customer.includes(0)) {
      const indexZero = this.filter.customer.findIndex((x) => x == 0);

      if (indexZero != -1) {
        this.filter.customer.splice(indexZero, 1);
        this.filter.customer = [...this.filter.customer];
      }
    }
  }

  public checkSuppliers() {
    if (this.filter.supplier.length > 1 && this.filter.supplier.includes(0)) {
      const indexZero = this.filter.supplier.findIndex((x) => x == 0);

      if (indexZero != -1) {
        this.filter.supplier.splice(indexZero, 1);
        this.filter.supplier = [...this.filter.supplier];
      }
    }
  }

  public resetCustomers() {
    this.filter.customer = [0];
    this.filter.customer = [...this.filter.customer];
  }

  public resetSuppliers() {
    this.filter.supplier = [0];
    this.filter.supplier = [...this.filter.supplier];
  }

  @HostListener('window:scroll', ['$event'])
  public scrollWindow(event) {
    if (window.pageYOffset > 100) {
      this.showHeader = false;
    } else {
      this.showHeader = true;
    }
  }

  public buttonAction(type) {
    let text = '';

      text = this.translate.instant('areYouSureYouWantToDeleteRabats') + ' (' + this.selected.length + ')';

    const dialogRef = this.dialog.open(DialogComponent, {
      data: {type: 'actionButton', text}, panelClass: 'warningDialog'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
          const ids = [];
          this.selected.forEach((x) => {
            ids.push(x.id);
          });

          this.apiService.deleteRabats(ids).subscribe(
            (data) => {
              this.rabats.forEach((rabat) => {
                ids.forEach((id) => {
                  if (rabat.id == id ) {
                    const index = this.rabats.findIndex( (x) => x.id === rabat.id);
                    this.rabats.splice(index, 1);
                  }
                });
              });
              this.rabats = [...this.rabats];
              this.selected = [];
            },
            (err) => {
              this.main.autoLogin(err.status);
            },
          );
        }
    });
  }

  public onResized() {
    if (window.innerWidth > 800) {
      this.showText = true;
      this.logoWidth = 30;
    } else {
      this.logoWidth = 50;
      this.showText = false;
    }
  }

  public onSort(event) {
    this.dir = event.sorts[0].dir;
    this.sort = event.sorts[0].prop;

    if (this.sort === 'createdAt') {
      this.sort = 'created_at';
    } else if (this.sort === 'deliveryPrice') {
      this.sort = 'delivery_price';
    } else if (this.sort === 'minDelivery') {
      this.sort = 'min_delivery';
    } else if (this.sort === 'numberOfOrders') {
      this.sort = 'number_of_orders';
    } else if (this.sort === 'isActive') {
      this.sort = 'is_active';
    } else if (this.sort === 'product') {
      this.sort = 'product_id';
    }

    this.filterRabats();
  }

  public onSelect({selected}) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  public onScroll() {
    this.page++;
    this.apiService.filterRabats(this.filter, this.sort, this.dir, this.page).subscribe(
      (data: { rabats: Rabat[], total: number }) => {
        this.rabats = [...this.rabats, ...data.rabats];
      },
      (err) => {
        this.main.autoLogin(err.status);
      },
    );
  }

  public getSelectedCount(type: number) {
    let count = 0;
    if (type === 1) {
      this.selected.forEach((x) => {
        if (x.isActive === type) {
          count++;
        }
      });
    } else if (type === 0) {
      this.selected.forEach((x) => {
        if (!x.isActive) {
          count++;
        }
      });
    }

    return count;
  }

  public onActivate(event) {
    let suppliers = [];
    if (this.supplier.role == 3) {
      suppliers = this.suppliers;
    } else {
      suppliers = [this.supplier];
    }
    if (event.type == 'click') {
      if (event.cellIndex != 0) {
        const rabat = event.row;
        const dialogRef = this.dialog.open(RabatComponentComponent, { maxWidth : '90vw !important',
          data: {rabat, mode: 'edit', customers: this.customers, suppliers, panelClass: 'warningDialog'}});

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {

          } else {
            this.filterRabats();
          }
        });
      }
    }
  }

  public addNew() {
    let suppliers = [];
    if (this.supplier.role == 3) {
      suppliers = this.suppliers;
    } else {
      suppliers = [this.supplier];
    }
    const dialogRef = this.dialog.open(RabatComponentComponent, { maxWidth : '90vw !important',
      data: {rabat: {}, mode: 'new', customers: this.customers, suppliers, panelClass: 'warningDialog'}});

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.rabats = [...this.rabats, ...[result]];
      }
    });
  }

  public validateDiscountType() {
    if (this.filter.discountType == 0) {
      this.filter.percentMax = 0;
      this.filter.percentMin = 0;
    } else if (this.filter.discountType == 1) {
      this.filter.priceMax = 0;
      this.filter.priceMin = 0;
    } else if (this.filter.discountType == -1) {
      this.filter.percentMax = 0;
      this.filter.percentMin = 0;
      this.filter.priceMax = 0;
      this.filter.priceMin = 0;
    }
  }

  public clearFilter() {
    this.filter = { dateFrom: -1, dateTo: -1, id: '', customer: [ 0 ], supplier: [ 0 ],
      condition: -1, discountType: -1, priceMin: 0, priceMax: 0, percentMin: 0, percentMax: 0 };
  }

  public findCustomerName(id) {
    const index = this.customers.findIndex((x) => x.id == id);

    if (index != -1) {
      return this.customers[index].legal_name;
    }
  }

  public findSupplierName(id) {
    const index = this.suppliers.findIndex((x) => x.id == id);

    if (index != -1) {
      return this.suppliers[index].name;
    }
  }

  public getActive(id) {
    if (id == 1) {
      return 'active';
    } else if (id == 0) {
      return 'unactive';
    } else if (id == -1) {
      return 'all';
    }
  }

  public getRowClass(row) {
    if (row.isActive == undefined) {
      return 'unactive-row';
    }
  }

  public filterRabats() {
    this.loading = true;
    this.apiService.filterRabats(this.filter, this.sort, this.dir, this.page).subscribe(
      (data: { rabats: Rabat[], total: number }) => {
        this.rabats = data.rabats;
        this.total = data.total;
        this.loading = false;
      },
      (err) => {
        this.main.autoLogin(err.status);
      },
    );
  }



}
